export function fetchGet() {
  const token = localStorage.getItem("apoloCRM_Token");
  const bearer = "Bearer " + token;
  const apiLanguage = localStorage.getItem("apoloCRM_Language");

  const fetchConfig = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: bearer,
      "Accept-Language": apiLanguage ?? "",
    },
    method: "GET",
  };

  return fetchConfig;
}

export function fetchPost(postBody, excludeContentType = false) {
  const token = localStorage.getItem("apoloCRM_Token");
  const bearer = "Bearer " + token;
  const apiLanguage = localStorage.getItem("apoloCRM_Language");

  let headers = {
    Authorization: bearer,
    Accept: "application/json",
    "Accept-Language": apiLanguage ?? "",
  };

  if (!excludeContentType) {
    headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: bearer,
      "Accept-Language": apiLanguage ?? "",
    };
  }

  const fetchConfig = {
    headers,
    method: "POST",
  };

  if (postBody) {
    fetchConfig.body = excludeContentType ? postBody : JSON.stringify(postBody);
  }
  return fetchConfig;
}

export function fetchPut(putBody, excludeContentType = false) {
  const token = localStorage.getItem("apoloCRM_Token");
  const bearer = "Bearer " + token;
  const apiLanguage = localStorage.getItem("apoloCRM_Language");

  let headers = {
    Authorization: bearer,
    Accept: "application/json",
    "Accept-Language": apiLanguage ?? "",
  };

  if (!excludeContentType) {
    headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: bearer,
      "Accept-Language": apiLanguage ?? "",
    };
  }

  const fetchConfig = {
    headers,
    method: "PUT",
  };

  if (putBody) {
    fetchConfig.body = excludeContentType ? putBody : JSON.stringify(putBody);
  }

  return fetchConfig;
}

export function fetchDelete() {
  const token = localStorage.getItem("apoloCRM_Token");
  const bearer = "Bearer " + token;
  const apiLanguage = localStorage.getItem("apoloCRM_Language");

  const fetchConfig = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: bearer,
      "Accept-Language": apiLanguage ?? "",
    },
    method: "DELETE",
  };

  return fetchConfig;
}

export function fetchPagination(filters) {
  return `?PageNum=${filters.pageNum}&PageIndex=${filters.pageIndex}&OrderByAscending=${filters.orderByAscending}&OrderByField=${filters.orderByField}&SearchString=${filters.searchString}&UTCOffset=${
    filters.utcOffset
  }&creationDate=${!filters.creationDate ? "" : filters.creationDate}&creationDateUntil=${!filters.creationDateUntil ? "" : filters.creationDateUntil}&CaseStates=${
    !filters.caseStates ? "" : filters.caseStates
  }&Provinces=${!filters.provinces ? "" : filters.provinces}&CaseTaxonomies=${!filters.caseTaxonomies ? "" : filters.caseTaxonomies}&EntryChannels=${
    !filters.entryChannels ? "" : filters.entryChannels
  }&Master=${!filters.master ? "" : filters.master}&SubStates=${!filters.subStates ? "" : filters.subStates}&Premium=${filters.premium === null ? "" : filters.premium}&CaseServices=${
    !filters.caseServices ? "" : filters.caseServices
  }`;
}

export function getConfig(type) {
  let result;
  switch (type) {
    case "GET":
      result = fetchGet;
      break;
    case "POST":
      result = fetchPost;
      break;
    case "PUT":
      result = fetchPut;
      break;
    case "DELETE":
      result = fetchDelete;
      break;
    default:
      result = fetchGet;
  }
  return result;
}
